import { AbstractFacade } from '@goparrot/axios';
import { plainToInstanceWithLVS } from '@goparrot/common';
import deepmerge from 'deepmerge';
import { ReadLoyaltyUserStatusDto, ReadPreparedSpendRuleDto } from '../dto';
import { LoyaltyUserStatusExposeGroup } from '../interface';
export class LoyaltyApiMerchantFacade extends AbstractFacade {
    constructor(config = {}, interceptors = {}) {
        super(deepmerge.all([
            {
                axiosConfig: {
                    baseURL: process.env.GOPARROT_PLATFORM_SERVICE_LOYALTY_POINTS,
                },
            },
            config,
        ]), interceptors);
    }
    async userStatus(merchantId, userId) {
        const response = await this.client.get(`/api/v2/merchants/${merchantId}/users/${userId}/get-user-status`);
        return plainToInstanceWithLVS(ReadLoyaltyUserStatusDto, response.data, { groups: [LoyaltyUserStatusExposeGroup.READ] });
    }
    async adjustPoints(merchantId, userId, points) {
        const response = await this.client.put(`/api/v2/merchants/${merchantId}/users/${userId}/adjust-points`, { points });
        return response.data;
    }
    async getLoyaltyDiscounts(merchantId, userId) {
        const response = await this.client.get(`/api/v2/merchants/${merchantId}/users/${userId}/loyalty-discounts`);
        return plainToInstanceWithLVS(ReadPreparedSpendRuleDto, response.data, { groups: [LoyaltyUserStatusExposeGroup.READ] });
    }
}
//# sourceMappingURL=LoyaltyApiMerchantFacade.js.map